import { ShortbreadUiContext } from "@amzn/xb-hooks";
import { PropsWithChildren } from "react";
import { useShortbread } from "../../hooks/useShortbread";

export const UseShortbreadUiHookProvider = ({ children }: PropsWithChildren) => {
  const [shortbread] = useShortbread();
  return <ShortbreadUiContext.Provider value={shortbread}>{children}</ShortbreadUiContext.Provider>;
};
